import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const supportEmail = "support@telvix.com.pk";
  const contactNumber = "+92 (306) ***-***";
  const addressLocation = "Mian Channu, Punjab, Pakistan";
  return (
    <footer className="position-relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
      color: '#ffffff',
      padding: '4rem 0 2rem',
      position: 'relative',
      zIndex: 1
    }}>
      {/* Decorative elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.1) 1px, transparent 0)',
        backgroundSize: '30px 30px',
        opacity: 0.2,
        zIndex: -1
      }}></div>
      
      <Container className="position-relative">
        <Row className="g-4">
          {/* Company Info */}
          <Col lg={4} className="mb-4 mb-lg-0">
            <h5 className="text-white mb-4 fw-bold">Telvix</h5>
            <p className="text-white-50 mb-4" style={{ maxWidth: '300px' }}>
              Delivering lightning-fast internet services with 99.9% uptime and exceptional customer support.
            </p>
            <div className="social-links d-flex gap-3">
              {[
                { icon: 'facebook-f', color: '#4267B2' },
                { icon: 'twitter', color: '#1DA1F2' },
                { icon: 'instagram', color: '#E1306C' },
                { icon: 'linkedin-in', color: '#0077B5' },
                { icon: 'youtube', color: '#FF0000' }
              ].map((social, index) => (
                <a 
                  key={index}
                  href="#" 
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: '40px',
                    height: '40px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = social.color;
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className={`fab fa-${social.icon}`}></i>
                </a>
              ))}
            </div>
          </Col>
          
          {/* Quick Links */}
          <Col md={4} lg={2} className="mb-4 mb-md-0">
            <h6 className="text-white mb-4 fw-bold">Quick Links</h6>
            <ul className="list-unstyled">
              {['Home', 'About Us', 'Services', 'Plans', 'Coverage', 'Contact'].map((item, index) => (
                <li key={index} className="mb-2">
                  <a 
                    href={`#${item.toLowerCase().replace(' ', '-')}`} 
                    className="text-white-50 text-decoration-none d-inline-block py-1"
                    style={{
                      transition: 'all 0.3s ease',
                      borderBottom: '1px solid transparent'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
                      e.currentTarget.style.borderBottomColor = 'transparent';
                    }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
          
          {/* Contact Info */}
          <Col md={4} lg={3} className="mb-4 mb-md-0">
            <h6 className="text-white mb-4 fw-bold">Contact Us</h6>
            <ul className="list-unstyled text-white-50">
              <li className="mb-3 d-flex align-items-start">
                <i className="fas fa-map-marker-alt me-3 mt-1"></i>
                <span>{addressLocation}</span>
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="fas fa-phone-alt me-3"></i>
                <span>{contactNumber}</span>
              </li>
              <li className="d-flex align-items-center">
                <i className="fas fa-envelope me-3"></i>
                <span>{supportEmail}</span>
              </li>
            </ul>
          </Col>
          
          {/* Newsletter */}
          <Col md={4} lg={3}>
            <h6 className="text-white mb-4 fw-bold">Newsletter</h6>
            <p className="text-white-50 mb-3">Subscribe to our newsletter for the latest updates.</p>
            <div className="input-group mb-3">
              <input 
                type="email" 
                className="form-control bg-transparent text-white border-end-0" 
                placeholder="Your email"
                style={{
                  borderColor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white !important',
                  boxShadow: 'none'
                }}
              />
              <button 
                className="btn btn-primary px-3"
                style={{
                  background: 'linear-gradient(45deg, #4f46e5, #7c3aed)',
                  border: 'none',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(45deg, #4338ca, #6d28d9)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(45deg, #4f46e5, #7c3aed)';
                }}
              >
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
          </Col>
        </Row>
        
        {/* Copyright */}
        <Row className="mt-5 pt-4 border-top border-opacity-10">
                   <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0 text-white-50">
              &copy; {currentYear} Telvix. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3">
              
              {/* <Link 
                to="/privacy" 
                className="text-white-50 text-decoration-none"
                style={{
                  transition: 'all 0.3s ease',
                  fontSize: '0.9rem'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = 'white'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-white-50 text-decoration-none"
                style={{
                  transition: 'all 0.3s ease',
                  fontSize: '0.9rem'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = 'white'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}
              >
                Terms of Service
              </Link>
              */}
              <a 
                href="#contact" 
                className="text-white-50 text-decoration-none"
                style={{
                  transition: 'all 0.3s ease',
                  fontSize: '0.9rem'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = 'white'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}
              >
                Contact Us
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
